import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { VideoPlayerCard } from '@flocasts/experience-service-types'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'

@Component({
  selector: 'flo-video-player-card',
  templateUrl: './video-player-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoPlayerCardComponent {
  @Input()
  video: VideoPlayerCard

  public trackById = trackById
}
